import React, { useState, useEffect, useMemo } from "react";
import {
  Heading,
  HEADING_TYPES,
  IconAdd,
  IconRemove,
  Content,
  TextArea,
  INPUT_SIZES,
  ICON_SIZE,
} from "cdk-radial";

const ChangeLog = ({ className, ...props }) => {
  const [addDiffList, rmDiffList] = useMemo(
    () => (props.diffLists.length > 0 ? props.diffLists : [[], []]),
    [props.diffLists]
  );

  return (
    <div
      style={{
        margin: "5px",
        padding: "12px",
      }}
    >
      {props.diffLists.length > 0 && (
        <Heading
          style={{ display: "flex", justifyContent: "center" }}
          headingType={HEADING_TYPES.HEADING_2}
        >
          Change Log
        </Heading>
      )}
      <ul style={{ listStyleType: "none", paddingInlineStart: "0"}}>
        {/* {addDiffList.length > 0 && (
          <Heading headingType={HEADING_TYPES.SUBTITLE_1}>Additions</Heading>
        )} */}
        {addDiffList.map((role) => (
          <li
            key={role.id}
            name="change-log-added-role"
            id={`change-log-added-role-${role.id}`}
            data-testid={`change-log-added-role-${role.id}`}
          >
            <Content
              style={{
                margin: "8px",
                alignItems: "center",
                display: "flex",
              }}
            >
              <IconAdd height={ICON_SIZE.SMALL} width={ICON_SIZE.SMALL} style={{flexShrink: 0}}/>
              {role.name}
            </Content>
          </li>
        ))}
        {/* {rmDiffList.length > 0 && (
          <Heading headingType={HEADING_TYPES.SUBTITLE_1}>Removals</Heading>
        )} */}
        {rmDiffList.map((role) => (
          <li
            key={role.id}
            name="change-log-removed-role"
            id={`change-log-removed-role-${role.id}`}
            data-testid={`change-log-removed-role-${role.id}`}
          >
            <Content
              style={{
                margin: "8px",
                alignItems: "center",
                display: "flex",
              }}
            >
              <IconRemove height={ICON_SIZE.SMALL} width={ICON_SIZE.SMALL} style={{flexShrink: 0}}/>
              {role.name}
            </Content>
          </li>
        ))}
      </ul>
      {props.diffLists.length > 0 && (
        <TextArea
          enableCustomValidation
          dataTestId="reason-text-area"
          errorMessage="Must have reason"
          hasError={props.reasonHasError}
          id="reason-text-area"
          label="Reason"
          name="reason-text-area"
          onChange={props.handleReasonChange}
          placeholder="Give reason for role assignment"
          size={INPUT_SIZES.STANDARD}
          value={props.reasonText}
          hasCharacterCount
          maxLength={200}
          isRequired
        />
      )}
    </div>
  );
};

export default ChangeLog;
